import React, { useCallback, useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import CommonService from "../../services/common.service";
import moment from "moment";
import GangtokService from "../../services/gangtok.service";

function ChartDuty({ depo }) {
  const [loading, setLoading] = useState(false);
  const [activeYearly, setActiveYearly] = useState(1); //1-7days, 2-Monthly, 3-Yearly

  const location = useLocation();

  const [graphDataNew, setGraphDataNew] = useState([]);

  const fetchChallanCount = useCallback(() => {
    setLoading(true);
    const type = activeYearly.toString();

    GangtokService.getChartDutyReport(type)
      .then((resp) => {
        setLoading(false);
        setGraphDataNew(resp.data);
      })
      .catch((e) => console.log(e));
  }, [activeYearly]);

  useEffect(() => {
    fetchChallanCount();
  }, [fetchChallanCount, activeYearly]);

  // console.log(graphDataNew);

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  const generateLast7DaysData = () => {
    if (graphDataNew.length != 0) {
      const data = graphDataNew.map((item) =>
        moment(item.amounttype, "YYYY-MM-DD").format("DD-MM-YY")
      );

      return data;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    if (graphDataNew.length != 0) {
      const data = graphDataNew.map((itm) => itm.amounttype);
      return data;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 1
      ? generateLast7DaysData()
      : activeYearly === 2
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const chartData = {
    labels: data,
    datasets: [
      {
        label: "Scheduled Duty",
        data: graphDataNew.map((item) => item.amount),
        backgroundColor: "rgb(103, 145, 235)",
        categoryPercentage: activeYearly === 2 ? 0.2 : 0.34,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        },
        borderSkipped: false,
      },
    ],
  };

  const options = {
    type: "bar",
    stacked: true,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",

        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },
      },
      legend: {
        display: false,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          drawOnChartArea: true,
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          drawOnChartArea: true,
        },
        ticks: {
          beginAtZero: true,
        },
        suggestedMin: 0,
        suggestedMax: 10,
        title: {
          display: true,
          text: "Scheduled Duty Count",
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Duty Report</div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
      </div>
      <div className="mt-3" style={{ height: "100%" }}>
        {loading ? (
          <>
            <div className="loading-area">
              <div
                class="spinner-border"
                style={{ color: "rgb(247, 177, 140)" }}
                role="status"
              >
                <span class="sr-only"></span>
              </div>
              <span>Data is Loading...</span>
            </div>
          </>
        ) : graphDataNew.length != 0 ? (
          <>
            <Bar data={chartData} options={options} width={600} height={275} />
          </>
        ) : (
          <div className="text-center">No Records Found </div>
        )}
      </div>
    </>
  );
}

export default ChartDuty;
